<template>
    <div class="modal fade z-index-1001" id="processBpmModal" tabindex="-1" aria-labelledby="processBpmModalLabel" @keydown.esc="closable && modalHidden()">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div v-if="!this.loader && processComponentData" class="modal-content">
          <div class="modal-header p-5">
            <h5 class="modal-title" id="processBpmModalLabel">{{ processComponentData.title }}</h5>
            <button v-if="closable" type="button" @click="closeModal" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-5">
            <component :is="processComponentData.component" :process="process" @update-process="updateProcess" @close-modal="closeModal" />
          </div>
          <div class="modal-footer p-3 justify-content-between">
            <button
                v-if="closable"
                @click="closeModal"
                type="button"
                class="btn btn-sm btn-secondary"
                data-bs-dismiss="modal"
            >Закрыть</button>
          </div>
        </div>
        <div v-else class="modal-content">
          <loader-full style="height: 400px"/>
        </div>
      </div>
    </div>
  </template>

<script>
/* global bootstrap */
// Other
import LoaderFull   from '@/components/Main/LoaderFull'
import ProcessBpmClientKdp from '@/components/Form/Bpm/Process/ProcessBpmClientKdp'
import ProcessBpmRulesAck from '@/components/Form/Bpm/Process/ProcessBpmRulesAck'
import ProcessBpmSignMethod from '@/components/Form/Bpm/Process/ProcessBpmSignMethod'
import ProcessBpmPaymentMethod from '@/components/Form/Bpm/Process/ProcessBpmPaymentMethod'
import ProcessBpmPhoneConfirm from '@/components/Form/Bpm/Process/ProcessBpmPhoneConfirm'

export default {
  name: 'ProcessBpmModal',
  components: {
    LoaderFull,
    ProcessBpmClientKdp,
    ProcessBpmRulesAck,
    ProcessBpmSignMethod,
    ProcessBpmPaymentMethod,
    ProcessBpmPhoneConfirm
  },
  props: {
    process: {
      type: Object,
      required: false,
      default: null,
    },
    closable: {
      type: Boolean,
      default: true,
    }
  },
  emits: ['close-modal', 'update-process'],
  data() {
    return {
      loader: false
    }
  },
  computed: {
    processComponentData() {
      let data = {
        'kdp': {
          'title': 'Отправка КДП',
          'component': ProcessBpmClientKdp
        },
        'rules': {
          'title': 'Ознакомление с правилами',
          'component': ProcessBpmRulesAck
        },
        'sign': {
          'title': 'Способ подписания ЗА',
          'component': ProcessBpmSignMethod
        },
        'payment': {
          'title': 'Способ оплаты',
          'component': ProcessBpmPaymentMethod
        },
        'phone': {
          'title': 'Подтверждение номера телефона',
          'component': ProcessBpmPhoneConfirm
        }
      }
      const action = this.process && this.process.process_data
        ? this.process.process_data.waiting_action
        : null
      if (!action) {
        return null
      }
      return data[action] || null
    }
  },
  methods: {
    modalHidden() {
      const myModalEl = document.getElementById('processBpmModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    updateProcess(data, id) {
      this.$emit('update-process', data, id)
    },
    closeModal() {
      this.modalHidden()
      this.$emit('close-modal')
    }
  }
}
</script>

<style scoped>
.z-index-1001 {
  z-index: 9999;
}
.btn-outline-primary:hover {
    color: #FFF !important;
}
.btn-outline-primary:hover > i {
    color: #FFF !important;
}
</style>